import React, {Fragment, useState} from 'react';
import {connect} from "react-redux";
import DropZone from "react-dropzone";
import isEmpty from "lodash/isEmpty";

import {hostedImageUrl} from "../../misc";
import {analyzeContract} from "./contractsAsyncActions";
import {CONTRACTS_VIEWS} from "./contractsReducer";
import {setContractsView, updateContractsList} from "./contractsActions";


const ContractsUpload = (props) => {

  const {setContractsView, contractsList, updateContractsList} = props;

  const [busy, setBusy] = useState(false);
  const [contractUploaded, setContractUploaded] = useState(false);
  const [errorParsing, setErrorParsing] = useState(false);

  const handleFileDrop = async (acceptedFiles) => {
    if (isEmpty(acceptedFiles)) {
      return;
    }
    setBusy(true);
    setContractUploaded(false);
    const newContracts = await analyzeContract(acceptedFiles[0], contractsList);
    console.log("newContracts", newContracts);
    setContractUploaded(true);
    setBusy(false);
    if (!newContracts) {
      setErrorParsing(true);
      return
    }
    updateContractsList(newContracts);
    setTimeout(() => {
      setContractsView(CONTRACTS_VIEWS.contracts)
    }, 2000)
  }

  if (contractUploaded && !busy && !errorParsing) {
    return (
      <div className="flex flex--center flex--column" style={{height: "100%"}}>
        <div className="success-title">Success!</div>
        <div className="success-message">Contracts Successfully Uploaded</div>
      </div>
    )
  }

  return (
    <DropZone rejectStyle={{'boxShadow': '0 0 1em yellow inset'}}
              accept=".pdf"
              onDrop={handleFileDrop}
              disabled={busy}
              multiple={false}
              className="drag-and-drop flex flex--center flex--column">
      {!busy && contractUploaded && errorParsing ? (
        <Fragment>
          <div className="error-title">Error</div>
          <div className="error-message">The file does not contain valid markup tags.</div>
          {/*<div className="error-message">Uploaded file does not have all required fields.</div>*/}
        </Fragment>
      ) : null}
      <div id="dragdrop-icon">
        {!busy && !contractUploaded ? (
          <Fragment>
            <img alt="" src={hostedImageUrl('/images/icon-folder.svg')}/>
            <div className="dragdrop-text">Drag and Drop Files</div>
            <div className="dragdrop-subtext">Supported File Formats: PDF Only</div>
            <div id="file-selection">+ Select files from Browser</div>
          </Fragment>
        ) : null}
        {busy ? (
          <Fragment>
            <img alt="" src={hostedImageUrl('/images/spinner.gif')} id="spinner"/>
            <div id="please-wait-info">Please Wait…</div>
            <div id="parsing-info">Uploading & Parsing Document</div>
          </Fragment>
        ) : null}
      </div>
    </DropZone>
  )
};

const mapStateToProps = (store) => {
  const {contractsList} = store.contractsState;
  return {
    contractsList,
  }
};

const mapDispatchToProps = {
  analyzeContract,
  setContractsView,
  updateContractsList,
};

export default connect(mapStateToProps, mapDispatchToProps)(ContractsUpload)
